import { Injectable } from '@angular/core';
import { HttpInterceptor, HttpHandler, HttpRequest, HttpEvent, HttpResponse, HttpErrorResponse } from '@angular/common/http';
import { Observable } from 'rxjs-compat';

import { AuthService } from 'src/services/auth.service';
import { LocalStoreManager } from 'src/services/local-store-manager.service';
import { NgxUiLoaderService } from 'ngx-ui-loader';
import { tap } from 'rxjs/operators/tap';

const TTL = 40;
@Injectable({
    providedIn: 'root'
})
export class AuthInterceptor implements HttpInterceptor {
    authToken: string;
    constructor(
        private auth: AuthService,
        private cache: LocalStoreManager,
        private spinner: NgxUiLoaderService,
    ) {
    }
    urlValidation(req: HttpRequest<any>): boolean {
        const filte = req.url.toLocaleLowerCase();
        const validation = filte.includes('i18n') || filte.includes('test') || filte.includes('waiters') || filte.includes('token') || filte.includes('goodsgrouplist') || filte.includes('setting') || filte.includes('savefactor') || filte.includes('tables') || filte.includes('Waiters')
            || filte.includes('GetFactor') || filte.includes('IntegratedFactor') || filte.includes('UpdateFactors') || filte.includes('CheckInventory') || filte.includes('TablesGroup') || filte.includes('GetTableFactor')
            || filte.includes('UpdateFactorState') || filte.includes('TableHasOrder') || filte.includes('CallWaiters')
            || filte.includes('GetTableOrder') || filte.includes('SystemValidation') || filte.includes('GetTableTimeLeft')
            || filte.includes('GetDigitalMenuFactorCount') || filte.includes('SystemLanguage') || filte.includes('OnlinePaymentResult')|| filte.includes('SocialMedia')
            || filte.includes('AllTables');
        return validation;
    }
    intercept(req: HttpRequest<any>, next: HttpHandler) {
        //if (req && !req.url.includes('/i18n/') ) {
        //  this.spinner.start();
        //}
        if (!this.urlValidation(req)) {
             //this.authToken = this.auth.getAuthorizationToken();
            const authReq = req.clone({
                headers: req.headers.set('Authorization', 'Bearer ' + this.authToken)
            });
            if (!this.isMultilanguage(authReq)) {
                // this.messge.present();
            }
            //this.spinner.stopAll();
            return next.handle(authReq);
            // return this.sendRequest(authReq, next);
        } else {
            if (!this.isMultilanguage(req)) {
                // this.messge.present();
            }
            // return next.handle(req);
            return this.sendRequest(req, next);
        }
    }
    isMultilanguage(req: HttpRequest<any>): boolean {
        const filte = req.url.toLocaleLowerCase();
        const validation = filte.includes('i18n');
        return validation;
    }

    sendRequest(
        req: HttpRequest<any>,
        next: HttpHandler
    ): Observable<HttpEvent<any>> {
        // try {
        if (req && !req.url.includes('/i18n/')) {
            this.spinner.start();
        }
        return next.handle(req).pipe(
            tap(event => {
                if (event instanceof HttpResponse) {
                    // if (event.url !== 'http://localhost:2121/GoodsGroupList') {
                    //  this.spinner.stop();
                    // }
                    this.spinner.stopAll();
                }
                if (event instanceof HttpErrorResponse) {
                    this.spinner.stopAll();
                }
                //  this.spinner.stopAll();
            })
        );
        // } catch (error) {
        //  this.spinner.stopAll();
        //  return next.handle(req);
        // }
    }
}
